module.exports = __webpack_public_path__ + "img/nubocam.54701914.svg";